import React from 'react'
import injectJss from 'react-jss'
import styleGuide from 'aria-viewer/tour/constants/styleGuide'
import { onetrust } from 'aria-viewer/core/analyticsManager'

const styles = {
    privacyPreferences: {
        position: 'absolute',
        bottom: '16px',
        left: '210px',
        width: 'fit-content',
        background: 'none',
        border: 'none',
        color: styleGuide.colors.white,
        cursor: 'pointer',
        fontSize: '14px',
        zIndex: '10',

        '@media screen and (max-width: 1000px)': {
            bottom: '0',
            left: '9px',
            fontSize: '11px',
        },
    },
}

const PrivacyPreferences = ({ classes }) => {
    return (
        <button type="button" className={classes.privacyPreferences} onClick={onetrust.togglePrivacyPreferencesDisplay}>
            Privacy Preferences
        </button>
    )
}

export default injectJss(styles)(PrivacyPreferences)
